import { useCallback } from 'react';
import { api } from 'src/assets/static/ApiRoutes';
import useAsync from 'src/hooks/useAsync';
import useAuth from 'src/hooks/useAuth';
import axiosInstance from 'src/utils/axios';

const useSaveGLMasks = () => {
  const { companyId } = useAuth();  
  const call = useCallback(
    async (request?: { glMasks?: string[]; glMaskRequired?: boolean }) => {
      try {        
        const response = await axiosInstance.post(api.saveGLCodeFormats, {
          companyId,
          glMasks: request?.glMasks,
          setGlMask: request?.glMaskRequired,
        });        
        return response.data;        
      } catch (error) {
        throw new Error(error);
      }
    },
    [companyId]
  );

  const { execute, isLoading } = useAsync(call, false);

  return {
    saveGLFormats: execute,
    isSavingGLFormats: isLoading,    
  };
};

export default useSaveGLMasks;
